import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ClawbackRewardDialogResult {
  reason: string;
  skipStripeRefund: boolean;
  externalStripeRefundId: string;
}

@Component({
    selector: 'app-clawback-reward-dialog',
    templateUrl: './clawbackrewarddialog.component.html',
    styleUrls: ['./clawbackrewarddialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClawbackRewardDialogComponent {
  public form;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ClawbackRewardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ClawbackRewardDialogModel,
  ) {
    this.form = this.formBuilder.group({
      reason: new UntypedFormControl('', [Validators.required]),
      skipStripeRefund: new UntypedFormControl(false),
      externalStripeRefundId: new UntypedFormControl(''),
    });
  }

  get rewardName(): string {
    const firstName = this.data.historyItem?.firstName || '';
    const lastName = this.data.historyItem?.lastName || '';
    return `${firstName} ${lastName}`.trim() || this.data.historyItem?.email || 'this member';
  }

  get amount(): string {
    return Number(this.data.historyItem?.amount || 0).toFixed(2);
  }

  clawbackClicked(): void {
    const result: ClawbackRewardDialogResult = {
      reason: `${this.form.get('reason')?.value || ''}`.trim(),
      skipStripeRefund: this.form.get('skipStripeRefund')?.value === true,
      externalStripeRefundId: `${this.form.get('externalStripeRefundId')?.value || ''}`.trim(),
    };
    this.dialogRef.close(result);
  }

  onDismiss(): void {
    this.dialogRef.close(null);
  }
}

export class ClawbackRewardDialogModel {
  constructor(public historyItem: any) {
  }
}
